import "@yaireo/tagify/dist/tagify.css";
import logger from "~/lib/logger";

const log = logger();

export const initTree = (root: Element): void => {
  cleanupTree(root);

  const elements = root.querySelectorAll('textarea[data-tagify="true"]');

  // If there are no elements, abort before loading the library.
  if (elements.length === 0) {
    return;
  }

  renderAll(elements as NodeListOf<HTMLInputElement>).catch((reason) => {
    log.error("Failed to render tagify:", reason);
  });
};

const renderAll = async (
  elements: NodeListOf<HTMLInputElement>,
): Promise<void> => {
  const { default: Tagify } = await import("@yaireo/tagify");

  elements.forEach((el) => {
    const regexPattern = el.getAttribute("data-tagify-regex") ?? "";
    new Tagify(el, {
      pattern: new RegExp(regexPattern),
    });
  });
};

const cleanupTree = (root: Element): void => {
  // Remove any existing tagify elements.
  root.querySelectorAll("tags.tagify").forEach((element) => {
    element.remove();
  });
};
